import React, { useContext } from 'react';
import { WMCheckbox } from '@walkme/wm-ui';

import { AppTableContext } from '../../AppTableContext';

interface ICheckboxCell {
    rowData: { id?: string };
    disabled?: boolean;
}

const CheckboxCell = ({ rowData, disabled: propDisable }: ICheckboxCell) => {
    const { tableDataTestid, selectedIds, onTableDataChange, disabled } = useContext(AppTableContext);

    function onChange() {
        const ids = new Set(selectedIds);
        if (rowData.id) {
            if (ids.has(rowData.id)) {
                ids.delete(rowData.id);
            } else {
                ids.add(rowData.id);
            }
        }

        onTableDataChange?.({ selectedIds: Array.from(ids) });
    }

    return (
        <WMCheckbox
            ds2
            checked={!!(rowData.id && selectedIds.has(rowData.id))}
            onChange={onChange}
            onClick={e => e.stopPropagation()}
            inputProps={{ 'data-testid': `${rowData.id}-checked-${tableDataTestid}` } as $TSFixMe}
            disabled={propDisable || disabled}
        />
    );
};

export default CheckboxCell;
